/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './assessment-question.reducer';

export const AssessmentQuestionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const assessmentQuestionEntity = useAppSelector(state => state.assessmentQuestion.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="assessmentQuestionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.assessmentQuestion.detail.title">AssessmentQuestion</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.assessmentQuestion.id">Id</Translate>
            </span>
          </dt>
          <dd>{assessmentQuestionEntity.id}</dd>
          <dt>
            <span id="section">
              <Translate contentKey="tinyMedicRestApp.assessmentQuestion.section">Section</Translate>
            </span>
          </dt>
          <dd>{assessmentQuestionEntity.section}</dd>
          <dt>
            <span id="subSection">
              <Translate contentKey="tinyMedicRestApp.assessmentQuestion.subSection">Sub Section</Translate>
            </span>
          </dt>
          <dd>{assessmentQuestionEntity.subSection}</dd>
          <dt>
            <span id="question">
              <Translate contentKey="tinyMedicRestApp.assessmentQuestion.question">Question</Translate>
            </span>
          </dt>
          <dd>{assessmentQuestionEntity.question}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.assessmentQuestion.active">Active</Translate>
            </span>
          </dt>
          <dd>{assessmentQuestionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.assessmentQuestion.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{assessmentQuestionEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.assessmentQuestion.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{assessmentQuestionEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.assessmentQuestion.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{assessmentQuestionEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.assessmentQuestion.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{assessmentQuestionEntity.timestampentry}</dd>
        </dl>
        <Button tag={Link} to="/assessment-question" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/assessment-question/${assessmentQuestionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AssessmentQuestionDetail;
